export default "__VITE_ASSET__DSPigFnn__"